// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609290325/js/" + chunkId + "." + {"44":"38b7b278","225":"d84187ba","481":"d1b9160f","486":"18d40582","770":"4957ed7a"}[chunkId] + ".0.5883402196807601.chunk.js";
};